import { render } from "./CallStateBanner.vue.js?vue&type=template&id=7000ce6b!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallStateBanner.vue?vue&type=template&id=7000ce6b"
import script from "./CallStateBanner.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallStateBanner.vue?vue&type=script&lang=js"
export * from "./CallStateBanner.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallStateBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/SharedWeb/scripts/apps/video-engine/components/video-call/CallStateBanner.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7000ce6b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7000ce6b', __exports__)) {
    api.reload('7000ce6b', __exports__)
  }
  
  module.hot.accept("./CallStateBanner.vue.js?vue&type=template&id=7000ce6b!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./CallStateBanner.vue?vue&type=template&id=7000ce6b", () => {
    api.rerender('7000ce6b', render)
  })

}


export default __exports__